// Business calendar dates are not instants. Never apply the browser timezone.
export function formatProductionBusinessDate(value) {
  if (value == null) return 'Unavailable';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  if (!match) return 'Unavailable';
  const date = match[0].slice(0, 10);
  const parsed = new Date(`${date}T00:00:00.000Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date ? date : 'Unavailable';
}
